"use client";
// biome-ignore lint/correctness/noUnusedImports: the package compiles JSX with the classic runtime ("jsx": "react"), so React must be in scope.
import * as React from "react";
import type { PropsWithChildren } from "react";
import { cn } from "../../../lib/utils";
import {
  DialogFooter as ShadcnDialogFooter,
  DialogHeader as ShadcnDialogHeader,
  DialogTitle as ShadcnDialogTitle,
} from "../dialog";

type DefaultDialogHeaderProps = {
  title: string;
  subTitle?: string;
  className?: string;
};

export const DefaultDialogHeader = ({ title, subTitle, className }: DefaultDialogHeaderProps) => {
  return (
    <ShadcnDialogHeader className={cn("bg-raised", className)}>
      <ShadcnDialogTitle className="flex flex-col gap-0.5 px-6 pt-6 pb-1 pr-14 font-display text-lg text-gray-12">
        <span className="leading-7">{title}</span>
        {subTitle && (
          <span className="text-gray-11 leading-5 text-sm font-normal font-sans tracking-normal [font-stretch:100%]">
            {subTitle}
          </span>
        )}
      </ShadcnDialogTitle>
    </ShadcnDialogHeader>
  );
};

type DefaultDialogContentAreaProps = PropsWithChildren<{
  className?: string;
}>;

export const DefaultDialogContentArea = ({
  children,
  className,
}: DefaultDialogContentAreaProps) => {
  return (
    <div
      className={cn(
        "bg-raised flex flex-col gap-4 px-6 pt-4 pb-6 text-gray-11 overflow-y-auto scrollbar-hide grow",
        className,
      )}
    >
      {children}
    </div>
  );
};

type DefaultDialogFooterProps = PropsWithChildren<{
  className?: string;
}>;

export const DefaultDialogFooter = ({ children, className }: DefaultDialogFooterProps) => {
  return (
    <ShadcnDialogFooter className={cn("px-6 py-4 border-t bg-sunken/70 text-gray-9", className)}>
      {children}
    </ShadcnDialogFooter>
  );
};
